import { useState } from 'react';
import { useOrderManualVerificationUpdates } from '../../../services/serviceSocket';
import { useDispatch } from 'react-redux';
import { CART_MANUAL_VERIF_SUCCESS } from '../../../constants/cartConstants';
import { posthogOrderCaptureEvent, posthogOrderGroupEvent } from '../../../posthog/orderEvent';
import {
  POSTHOG_CAPTURE_ORDER_MANUALLY_VERIFIED, POSTHOG_GROUP_ORDER,
  POSTHOG_ORDER_MANUALLY_VERIFIED_STATUS,
} from '../../../posthog/constants';

export const useManualVerification = (cartItems, axiosInstance) => {
  const [manualVerification, setManualVerification] = useState(false);
  const dispatch = useDispatch();

  function handleManualVerification(order) {
    dispatch({ type: CART_MANUAL_VERIF_SUCCESS, payload: order });
    setManualVerification(false);

    posthogOrderCaptureEvent(order, POSTHOG_CAPTURE_ORDER_MANUALLY_VERIFIED)
    posthogOrderGroupEvent(POSTHOG_GROUP_ORDER, POSTHOG_ORDER_MANUALLY_VERIFIED_STATUS, order);

    localStorage.setItem('isCheckStore', 'true');
    localStorage.removeItem('isCheckStoreAlreadyAsk');
  }

  const handleStatusUpdate = (change) => {
    if (change?.manualVerification) {
      handleManualVerification(change);
    }
  };

  useOrderManualVerificationUpdates(cartItems?._id, handleStatusUpdate);

  const checkIfOrderHasBeenManualyVerified = async () => {
    if (!cartItems?._id) return;
    if (!cartItems?.verification) return;

    try {
      const currentOrder = await axiosInstance.get(`/orders/${cartItems?._id}`);

      if (currentOrder?.data?.manualVerification) {
        console.info('info current order manualVerification', currentOrder?.data);
        handleManualVerification(currentOrder?.data);
        return true;
      }
      return false;
    } catch (error) {
      console.error('checkIfOrderHasBeenManualyVerified error', error);
      return false;
    }
  };

  return {
    manualVerification,
    setManualVerification,
    checkIfOrderHasBeenManualyVerified,
  };
};
